import {HTTP, ERROR} from '@/http-common';
import Vue from 'vue';
import _ from "lodash";

const state = {
  formBuilder: {
    modules: [],
    templates: [],
    templatesLoading: false,
    creatingFailed: false,
    duplicatingFailed: false,
    lastCreatedForm: {},
    organizationForms: [],
    organizationFormsModules: [],
    organizationFormsLoading: false,
    systemForms: [],
    systemFormsModules: [],
    systemFormsLoading: false,
    participantForms: [],
    participantFormsModules: [],
    participantFormsLoading: false,
    referralFormsLoading: false,
    referralForms: [],
    referralFormModule: {},
    formsWithSharedFields: []
  }
};

const mutations = {
  SET_LAST_CREATED_FORM(state, data) {
    state.formBuilder.lastCreatedForm = data
  },
  SET_CREATING_FAILED(state, data) {
    state.formBuilder.creatingFailed = data;
  },
  SET_DUPLICATING_FAILED(state, data) {
    state.formBuilder.duplicatingFailed = data;
  },
  SET_MODULES(state, data) {
    state.formBuilder.modules = data;
  },
  SET_FORMS_TEMPLATES(state, data) {
    state.formBuilder.templates = data;
  },
  SET_FORMS_TEMPLATES_LOADING(state, data) {
    state.formBuilder.templatesLoading = data;
  },
  SET_ORGANIZATION_FORMS(state, data) {
    state.formBuilder.organizationForms = data;
  },
  SET_ORGANIZATION_FORMS_MODULES(state, data) {
    state.formBuilder.organizationFormsModules = data;
  },
  SET_ORGANIZATION_FORMS_LOADING(state, data) {
    state.formBuilder.organizationFormsLoading = data;
  },
  SET_SYSTEM_FORMS(state, data) {
    state.formBuilder.systemForms = data;
  },
  SET_SYSTEM_FORMS_MODULES(state, data) {
    state.formBuilder.systemFormsModules = data;
  },
  SET_SYSTEM_FORMS_LOADING(state, data) {
    state.formBuilder.systemFormsLoading = data;
  },
  SET_PARTICIPANT_FORMS(state, data) {
    state.formBuilder.participantForms = data;
  },
  SET_PARTICIPANT_FORMS_MODULES(state, data) {
    state.formBuilder.participantFormsModules = data;
  },
  SET_REFERRAL_FORM_MODULE(state, data) {
    state.formBuilder.referralFormModule = data;
  },
  SET_PARTICIPANT_FORMS_LOADING(state, data) {
    state.formBuilder.participantFormsLoading = data;
  },
  SET_REFERRAL_FORMS_LOADING(state, data) {
    state.formBuilder.referralFormsLoading = data;
  },
  SET_REFERRAL_FORMS(state, data) {
    state.formBuilder.referralForms = data;
  },
  SET_FORMS_WITH_SHARED_FIELDS(state, data) {
    state.formBuilder.formsWithSharedFields = data;
  }
};

const getters = {
  getLastCreatedForm: state => state.formBuilder.lastCreatedForm,
  getCreatingFailed: state => state.formBuilder.creatingFailed,
  getDuplicatingFailed: state => state.formBuilder.creatingFailed,
  getModules: state => state.formBuilder.modules,
  getFormsTemplates: state => state.formBuilder.templates,
  getFormsTemplatesLoading: state => state.formBuilder.templatesLoading,
  getOrganizationForms: state => state.formBuilder.organizationForms,
  getOrganizationFormsModules: state => state.formBuilder.organizationFormsModules,
  getOrganizationFormsLoading: state => state.formBuilder.organizationFormsLoading,
  getSystemForms: state => state.formBuilder.systemForms,
  getSystemFormsModules: state => state.formBuilder.systemFormsModules,
  getSystemFormsLoading: state => state.formBuilder.systemFormsLoading,
  getParticipantForms: state => state.formBuilder.participantForms,
  getParticipantFormsModules: state => state.formBuilder.participantFormsModules,
  getParticipantFormsLoading: state => state.formBuilder.participantFormsLoading,
  getReferralFormsLoading: state => state.formBuilder.referralFormsLoading,
  getReferralForms: state => state.formBuilder.referralForms,
  getReferralFormModule: state => state.formBuilder.referralFormModule,
  getFormsWithSharedFields: state => state.formBuilder.formsWithSharedFields,
  getFormsWithSharedFieldsAlphabetical: state => {
    if (state.formBuilder.formsWithSharedFields && Array.isArray(state.formBuilder.formsWithSharedFields)){
      return state.formBuilder.formsWithSharedFields.sort( (a, b) => {
        const textA = a.name.toUpperCase();
        const textB = b.name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      })
    }

    return state.formBuilder.formsWithSharedFields
  }
};

const actions = {
  fetchModules: ({commit, state}, payload) => {
    if ((payload && payload.force) || state.formBuilder.modules.length === 0){
      return HTTP.get('form-builder/modules')
        .then(response => {
          ERROR(response);
          if (response.data.status === 'success') {
            commit('SET_MODULES', response.data.data);
          }
        }).catch(err => {
          console.log(err);
        })
    } else {
      return state.formBuilder.modules;
    }
  },
  fetchFormsTemplates: ({commit}) => {
    commit('SET_FORMS_TEMPLATES_LOADING', true);
    return HTTP.get('form-builder/templates').then(response => {
      ERROR(response);
      if (response.data.status === 'success') {
        let templates = _.sortBy(response.data.data.forms_templates, 'name');
        commit('SET_FORMS_TEMPLATES', templates);
        commit('SET_FORMS_TEMPLATES_LOADING', false);
      }
    }).catch(err => {
      console.log(err);
    })
  },
  fetchOrganizationForms: ({commit}, payload) => {
    commit('SET_ORGANIZATION_FORMS_LOADING', true);
    return HTTP.get('form-builder/organization-forms')
      .then(response => {
        ERROR(response);
        commit('SET_ORGANIZATION_FORMS', response.data.data.organization_forms);
        commit('SET_ORGANIZATION_FORMS_MODULES', response.data.data.organization_forms_modules);
        commit('SET_ORGANIZATION_FORMS_LOADING', false);
      })
  },
  fetchSystemForms: ({commit}, payload) => {
    commit('SET_SYSTEM_FORMS_LOADING', true);
    return HTTP.get('form-builder/system-forms')
      .then(response => {
        ERROR(response);
        commit('SET_SYSTEM_FORMS', response.data.data.system_forms);
        commit('SET_SYSTEM_FORMS_MODULES', response.data.data.system_forms_modules);
        commit('SET_SYSTEM_FORMS_LOADING', false);
      })
  },
  fetchParticipantForms: ({commit}, payload) => {
    commit('SET_PARTICIPANT_FORMS_LOADING', true);
    return HTTP.get('form-builder/participant-forms')
      .then(response => {
        ERROR(response);
        commit('SET_PARTICIPANT_FORMS', response.data.data.participant_forms);
        commit('SET_PARTICIPANT_FORMS_MODULES', response.data.data.participant_forms_modules);
        commit('SET_PARTICIPANT_FORMS_LOADING', false);
      })
  },
  fetchReferralForms: ({commit}, payload) => {
    commit('SET_REFERRAL_FORMS_LOADING', true);
    return HTTP.get('form-builder/referral-forms')
      .then(response => {
        ERROR(response);
        commit('SET_REFERRAL_FORM_MODULE', response.data.data.referral_forms_module)
        commit('SET_REFERRAL_FORMS', response.data.data.referral_forms);
        commit('SET_REFERRAL_FORMS_LOADING', false);
      })
  },
  createForm: ({commit}, payload) => {
    return HTTP.post('form/create', payload)
      .then(response => {
        ERROR(response);
        if (response.data.status === 'success') {
          commit('SET_CREATING_FAILED', false);
          commit('SET_LAST_CREATED_FORM', response.data.data);
          Vue.prototype.$notify('New form created!');
        } else {
          commit('SET_CREATING_FAILED', true);
          Vue.prototype.$notify({
            type: 'error',
            text: 'Creating new form failed!'
          });
        }
        return response.data.status === 'success';
      }).catch(err => {
        commit('SET_CREATING_FAILED', true);
        commit('SET_LAST_CREATED_FORM', {});
        console.log(err);
      })
  },
  duplicateForm: ({commit}, payload) => {
    return HTTP.post('form-builder/duplicate', payload)
      .then(response => {
        ERROR(response);
        if (response.data.status === 'success') {
          commit('SET_DUPLICATING_FAILED', false);
          commit('SET_LAST_CREATED_FORM', {
            id: response.data.data.id
          });
          Vue.prototype.$notify('Form duplicated.');
        } else {
          commit('SET_DUPLICATING_FAILED', true);
          Vue.prototype.$notify({
            type: 'error',
            text: 'Duplicate form failed!'
          });
        }
        return response.data.status === 'success';
      })
      .catch(err => {
        console.log(err);
      })
  },
  fetchFormsWithSharedFields: ({commit}, payload) => {
    return HTTP.post('form-builder/forms-with-shared-fields', {}).then(response => {
      commit('SET_FORMS_WITH_SHARED_FIELDS', response.data.data.forms);
    }).catch(error => {

    });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/formBuilderIndex.js